import React, { useState } from "react";
import Modal from "olive-react-myoneui/lib/Modal";
import Button from "olive-react-myoneui/lib/Button";
import { documentIcon, downloadBaseIcon } from "../../../constants/icons";

const PostDocument = ({
  className,
  fileType,
  docFileName,
  docName,
  docUploadDate,
}) => {
  const [modalShow, setModalShow] = useState(false);
  const modifiedFileURL = `${docFileName}#toolbar=0&navpanes=0&scrollbar=0`;

  const downloadFile = () => {
    const anchor    = document.createElement("a");
    anchor.href     = docFileName;
    anchor.target   = '_blank';
    anchor.download = docFileName;
    anchor.click();
  };

  const renderFile = () => {
    if (fileType === "image") {
      return <img src={docFileName} alt="Certificate" className="img-fluid" />;
    } else if (fileType === "pdf") {
      return (
        <iframe
          src={modifiedFileURL}
          title={docName}
          width="100%"
          height="128px"
        ></iframe>
      );
    } else if (fileType === "doc" || fileType === "docx") {
      return (
        <div className="doc-icon-wrapper">
          {documentIcon} <br />
          <p>Preview Not Available</p>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <div
        className="myk__stu-comm-doc-item"
        onClick={() => setModalShow(true)}
      >
        <div className={`myk__stu-doc-icon me-2`}>{documentIcon}</div>
        <div className="myk__stu-doc-meta">
          <h3>{docName}</h3>
          <p>{docUploadDate}</p>
        </div>
      </div>
      {/* Modal */}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName="myk__certificate-modal myk__st-comm-doc-modal px-0 py-3"
      >
        <Modal.Header className="justify-content-start pb-2 px-2">
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-start"
          >
            <h1>{docName}</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{renderFile()}</Modal.Body>
        <Modal.Footer className="text-end pt-3">
          <Button variant="default" onClick={() => setModalShow(false)}>
            Close
          </Button>
          <Button onClick={downloadFile}>
            {downloadBaseIcon} &nbsp; Download
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PostDocument;
